import { api } from "@/lib/api"
import { WorkspaceStackedBarChart } from "./workspace-stacked-bar-chart"

export function AITranslationsChart() {
	const query = api.analytics.aiTranslationsChart.useQuery({})

	return (
		<WorkspaceStackedBarChart
			title="AI Translations"
			data={query.data}
			isLoading={query.isLoading}
		/>
	)
}
